namespace Solovis.Portal.TxServices {

    export class TxSettings {

        public static useGridEditor(portalServices: Solovis.Portal.IPortalServices) {
            let solovisCustom = portalServices.customEnvironmentUserData();
            if (solovisCustom && solovisCustom.TxEditor) {
                if (solovisCustom.TxEditor.useGridEditor) {
                    return true;
                }
            }

            return false;
        }

        public static defaultTxIsStartOfDay(portalServices: Solovis.Portal.IPortalServices) {
            let solovisCustom = portalServices.customEnvironmentUserData();
            if (solovisCustom && solovisCustom.ModelDefaults) {
                if (solovisCustom.ModelDefaults.defaultTxIsStartOfDay) {
                    return true;
                }
            }

            return false;
        }

        public static getCustomPropIdsToEditForModelEnvironment(portalServices: Solovis.Portal.IPortalServices, modelEnv: InvData.ModelEnvironment): number[] {
            let propDefIds = [];

            // We trap exceptions and log to avoid bad configuration completely disabling tx editors.
            let solovisCustom = portalServices.customEnvironmentUserData();
            if (solovisCustom && solovisCustom.TxEditor && solovisCustom.TxEditor.customProperties) {
                for (let customPropRef of solovisCustom.TxEditor.customProperties) {
                    try {
                        let propDefCode = customPropRef.propDefCode;
                        let propDef = modelEnv.propertyDefinitions.tryGetByCode(propDefCode);
                        if (propDef) {
                            propDefIds.push(propDef.id);
                        }
                        else {
                            console.log("TxUtil._getCustomPropIdsToEdit missing property definition: " + propDefCode);
                        }
                    }
                    catch (ex) {
                        console.log("TxUtil._getCustomPropIdsToEdit error: ");
                        console.log(ex);
                    }
                }
            }

            return propDefIds;
        }
    }

}